export enum Bakery2bTabs {
  clients = 'clients',
  settings = 'settings',
  statistics = 'statistics',
}
